<template lang="">
    <v-chip
      small
      :color="
        type === 'maindomain' || type === 'purple'
          ? '#6A32E033'
          : type === 'subdomain' || type === 'premium'
          ? '#005EEA33'
          : type === 'addon'
          ? '#07C07E33'
          : type === 'free' || type === 'expires'
          ? '#FF7A2F26'
          : type === 'disabled'
          ? '#F2F2F7'
          : '#f2f2f7'
      "
    >
      <span
        class="p-3 font-weight-bold"
        :style="
          type === 'maindomain' || type === 'purple'
            ? 'color: #6A32E0'
            : type === 'subdomain' || type === 'premium'
            ? 'color: #005EEA'
            : type === 'addon'
            ? 'color: #07C07E'
            : type === 'free' || type === 'expires'
            ? 'color: #FF7A2F'
            : type === 'disabled'
            ? 'color: #797997'
            : 'color: #797997'
        "
      >
      <slot/>
      </span>
    </v-chip>
  </template>
  <script>
  export default {
    props: {
      type: String,
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v-chip {
    text-transform: capitalize;
    font-weight: $font-weight-bold;
    &.v-size--small{
      &.radius-sm{
        border-radius: 5px;
      }
      &.xs{
        height: 20px;
        padding: 2px 8px;
        > .v-chip__content{
          > span{
            font-size: 10px;
            line-height: 16px;
          }
        }
      }
    }
    &::before {
      display: none;
    }
  }
  </style>
  